import { Crop } from './crop';
import { TenantGeneralData } from './tenantGeneralData';

export class Plant extends TenantGeneralData {
  /* ROOTSTOCK */
  rootstock: string;
  plantsCount: number;
  plantsX: number;
  plantsY: number;
  plantsUnit: string;
  plantsPlantingDate: Date;
  plantsCuttingDate: Date;
  plantsHarvestingDate: Date;
  plantsUpdateDate: Date;
  plantsNote: string;

  crops: Array<Crop>;

  dateCreated: Date;
  lastUpdated: Date;

  constructor() {
    super();
    this.id = null;
    /* ROOTSTOCK */
    this.rootstock = null;
    this.plantsCount = null;
    this.plantsX = null;
    this.plantsY = null;
    this.plantsUnit = null;
    this.plantsPlantingDate = null;
    this.plantsCuttingDate = null;
    this.plantsHarvestingDate = null;
    this.plantsUpdateDate = null;
    this.plantsNote = null;

    this.crops = null;

    this.dateCreated = null;
    this.lastUpdated = null;
  }
}

export const PlantDateType = {
  PLANTING: 'plantsPlantingDate',
  CUTTING: 'plantsCuttingDate',
  HARVESTING: 'plantsHarvestingDate',
};

/*
*********** MODELLO DI BACKEND **********************
package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User
import grails.databinding.BindingFormat

class Plant {

    transient springSecurityService

    Long companyId = -1

    // ROOTSTOCK
    string      rootstock
    Double      plantsCount
    Double      plantsX
    Double      plantsY
    string      plantsUnit
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date        plantsPlantingDate
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date        plantsCuttingDate
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date        plantsHarvestingDate
    @BindingFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    Date        plantsUpdateDate
    string      plantsNote

    Date    dateCreated
    Date    lastUpdated

    static belongsTo = [crop: Crop]

    static constraints = {
        rootstock               blank: false, nullable: true
        plantsCount             blank: false, nullable: true
        plantsX                 blank: false, nullable: true
        plantsY                 blank: false, nullable: true
        plantsUnit              blank: false, nullable: true, inList:   ["m", "cm"]
        plantsPlantingDate      blank: false, nullable: true
        plantsCuttingDate       blank: false, nullable: true
        plantsHarvestingDate    blank: false, nullable: true
        plantsUpdateDate        blank: false, nullable: true
        plantsNote              blank: false, nullable: true
        dateCreated             nullable: true
        lastUpdated             nullable: true

    }
    static mapping = {
        autoTimestamp true
    }

    static transients = ['springSecurityService']

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }
}

*/
